export enum ButtonVariants {
  primary = 'primary',
  outline = 'outline',
  link = 'link-btn',
  plain = 'plain',
}
